import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PC_MLc_04 empLeaveData gets imported from api.js file
 */
import { empLeaveData } from '../service/api';

export default function EmployeeLeaveData() {

        /**
 * PC_MLc_02
 * The availabele , pending state variable is created for storing the response data
 */
    const [available, setavailable] = useState({});
    const [pending, setPending] = useState('');
    const navigate = useNavigate();


  /**
  * PC_Mlc_03
  * Use Efffect method is called 
  */

    useEffect(() => {
        fetchApi();
    }, []);

        /**
 * PC_MLc_06
 * The fetchApi function in the useEffects gets invoked which inturn call the empLeaveData() function with respective parameters
 */

    const fetchApi = async () => {
        const resp = await empLeaveData();

        if (resp?.data?.ResponseData.length) {
            setavailable(resp?.data?.ResponseData[0]);
            setPending(resp?.data?.ResponseData[1]);
        }
    };

        /**
 * PC_MLc_10
 * The response data gets stored in the pending and available variable and mapped to the respective divs
 */

    return (
        <div className="rounded-5 dashboard-container-background dashboard-team-card-size p-3">
            <div className="d-flex justify-content-between">
                <h1 className="tt-bold font-15 ">My Available Leaves</h1>
                <a className="semibold-text align-item-center font-12 text-decoration-none"  onClick={() => {navigate(`/leaveform`, { state: { switchTab: 'Dashboard' } });}}>
                    Apply Leave
                    <span>
                        <img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" />
                    </span>
                </a>
            </div>
            <div className="row">
                <div className="col-md-8 d-flex justify-content-around p-4">
                    <div class="position-relative">
                        <span className="badge dashboard-casual-availability font-28 green d-flex justify-content-center align-items-center tt-bold position-relative">
                            {available.casual}
                        </span>
                        <h2 className="font-12 bold-text mt-3 text-center">Casual</h2>
                        <img src="/Images/casual.png" className="position-absolute dashboard-leave-emoji-size dashboard-emoji-position" />
                    </div>
                    <div className="dashboard-border-line position-relative">
                        <span className="badge dashboard-sick-availability font-28 orange d-flex justify-content-center align-items-center tt-bold">
                            {available.sick}
                        </span>
                        <h2 className="font-12 bold-text mt-3 text-center">Sick</h2>
                        <img src="/Images/sick.png" className="position-absolute dashboard-leave-emoji-size dashboard-emoji-position" />
                    </div>
                </div>
                <div className="col-md-4 align-self-center">
                    <span className="badge dashboard-pending-availability font-28 blue d-flex align-items-center tt-bold">
                        <img src="/Images/pending.png" className="dashboard-pending-size me-1" />
                        {pending}
                    </span>
                    <h2 class="font-12 bold-text mt-3">Pending Request</h2>
                </div>
            </div>
        </div>
    );
}
